import React from 'react';

const ServicesTablet = () => {
    return (
        <div className='container contenedro_servicios_movil' style={{display:"flex", justifyContent:"center", alignItems:"center", marginTop:"50px"}}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                style={{width:"80%"}}
                viewBox="0 0 250.387 253.084"
            >
                <defs>
                    <clipPath id="clip-path">
                    <path
                        id="Trazado_146"
                        data-name="Trazado 146"
                        d="M313,116.379h17.246v53.835H313Zm0,0"
                        transform="translate(-313 -116.379)"
                        fill="#797979"
                    />
                    </clipPath>
                    <clipPath id="clip-path-2">
                    <path
                        id="Trazado_148"
                        data-name="Trazado 148"
                        d="M199,116.379h38.5v53.835H199Zm0,0"
                        transform="translate(-199 -116.379)"
                        fill="#797979"
                    />
                    </clipPath>
                    <clipPath id="clip-path-3">
                    <path
                        id="Trazado_155"
                        data-name="Trazado 155"
                        d="M116.379,318h53.835v16.22H116.379Zm0,0"
                        transform="translate(-116.379 -318)"
                        fill="#797979"
                    />
                    </clipPath>
                    <clipPath id="clip-path-4">
                    <path
                        id="Trazado_157"
                        data-name="Trazado 157"
                        d="M116.379,116.379h53.835v53.835H116.379Zm0,0"
                        transform="translate(-116.379 -116.379)"
                        fill="#797979"
                    />
                    </clipPath>
                    <clipPath id="clip-path-5">
                    <path
                        id="Trazado_160"
                        data-name="Trazado 160"
                        d="M210,74.422h37.11v29.1H210Zm0,0"
                        transform="translate(-210 -74.422)"
                        fill="#797979"
                    />
                    </clipPath>
                    <clipPath id="clip-path-6">
                    <path
                        id="Trazado_162"
                        data-name="Trazado 162"
                        d="M104,198h48.992v43.777H104Zm0,0"
                        transform="translate(-104 -198)"
                        fill="#797979"
                    />
                    </clipPath>
                    <clipPath id="clip-path-7">
                    <path
                        id="Trazado_1292"
                        data-name="Trazado 1292"
                        d="M163,43.488h36.41V97.321H163Zm0,0"
                        transform="translate(-163 -43.488)"
                        fill="#797979"
                    />
                    </clipPath>
                </defs>
                <g
                    id="Grupo_213"
                    data-name="Grupo 213"
                    transform="translate(21498.193 15878.266)"
                >
                    <g id="_1" data-name={1} transform="translate(-21318.467 -15709.615)">
                    <path
                        id="Trazado_133"
                        data-name="Trazado 133"
                        d="M360.792,389.625c-.956-1.159-2.491-1.4-4.5-1.4H335.406c-.938,0-1.123-.4-1.123-1.037,0-.71.806-.9,1-.94H355.5a1.988,1.988,0,0,0,1.867-1.465l3.351-13.824a1.471,1.471,0,0,0-.256-1.259,1.455,1.455,0,0,0-1.163-.544H331.955l-.532-2.173a1.992,1.992,0,0,0-1.865-1.465h-5.311a.712.712,0,0,0,0,1.424h5.311a.569.569,0,0,1,.482.378l4.328,17.732a2.384,2.384,0,0,0,1.04,4.6h20.884c1.93,0,2.886.247,3.405.881a.709.709,0,0,0,.551.259.7.7,0,0,0,.45-.161A.716.716,0,0,0,360.792,389.625Zm-9.877-14-.535,4.154h-9.1l-.569-4.154Zm-10.4-1.423-.489-3.607,11.538.018-.463,3.59H340.515Zm16.6,5.579h-5.3l.536-4.154h5.763Zm-6.915,1.422-.465,3.62h-7.771l-.493-3.62Zm-10.358-1.422h-5.292l-1.014-4.154h5.741Zm.193,1.422.5,3.62h-4.749l-.886-3.62Zm15.465,3.62h-4.328l.465-3.62h5.131l-.786,3.242A.563.563,0,0,1,355.5,384.827Zm3.833-14.2-.869,3.579h-5.926l.46-3.588Zm-20.743-.03.491,3.607h-5.893l-.884-3.618Zm0,0"
                        transform="translate(-301.635 -342.895)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_134"
                        data-name="Trazado 134"
                        d="M431.141,652.531a3.24,3.24,0,1,0,3.237,3.238A3.241,3.241,0,0,0,431.141,652.531Zm0,4.39a1.152,1.152,0,1,1,1.151-1.152A1.151,1.151,0,0,1,431.141,656.921Zm0,0"
                        transform="translate(-397.01 -605.178)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_135"
                        data-name="Trazado 135"
                        d="M666.037,652.531a3.24,3.24,0,1,0,3.238,3.238A3.241,3.241,0,0,0,666.037,652.531Zm0,4.39a1.152,1.152,0,1,1,1.151-1.152A1.149,1.149,0,0,1,666.037,656.921Zm0,0"
                        transform="translate(-611.67 -605.178)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_136"
                        data-name="Trazado 136"
                        d="M323.648,408.218a9.731,9.731,0,0,0,1.854-2.533l-1.311-5.371h-4.273a2.509,2.509,0,0,1-1.118-.271,3.709,3.709,0,0,0,.356.642C321.789,404.451,320.2,411.6,323.648,408.218Zm0,0"
                        transform="translate(-297.309 -374.444)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_137"
                        data-name="Trazado 137"
                        d="M98.787,147.539a21.439,21.439,0,0,1-8.7.551c-1.6-1.931-2.779-3.518.673-5.951,4.175-2.945.28-4.846-2.909-5.308s-4.745-7.281-6.532-10.492-3.257,2.111-4.512,3.908c-.868,1.248-3.5.315-5.04-.38A21.579,21.579,0,0,1,90.9,105.253c-.458,2.224-.778,5.9,1.687,7.168,3.626,1.862,1.98,1.372-3.173,2.329s-2.894,5.217,1.329,7.494c1,.54,1.409,1.022,1.5,1.489h5.042a3.824,3.824,0,0,1,3.631,2.854l.193.786h2.936c1.611-1.977,1.98-6.541-2.495-5.384-5.431,1.407-.065-5.939,2.872-5.966,2.476-.024,4.013-1.588,4.873-3.624a21.578,21.578,0,0,1,5.413,14.974h2.18a23.807,23.807,0,1,0-17.464,22.261A4.4,4.4,0,0,1,98.787,147.539Zm0,0"
                        transform="translate(-69.355 -102.927)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_138"
                        data-name="Trazado 138"
                        d="M162.816,234.788c1.628-1.38,2.949-1.5,3.676-4.108s-3.183-1.243-4.894.013a4.707,4.707,0,0,0-1.329,5.117C160.927,237.214,161.192,236.168,162.816,234.788Zm0,0"
                        transform="translate(-152.176 -218.316)"
                        fill="#797979"
                    />
                    </g>
                    <text
                    id="E-commerce"
                    transform="translate(-21288.807 -15631.182)"
                    fill="#8c8c8c"
                    fontSize={15}
                    fontFamily="HindMadurai-Regular, Hind Madurai"
                    letterSpacing="0.005em"
                    >
                    <tspan x="-40.53" y={0}>
                        E-commerce
                    </tspan>
                    </text>
                    <g id="_3" data-name={3} transform="translate(-21484.111 -15878.266)">
                    <path
                        id="Trazado_143"
                        data-name="Trazado 143"
                        d="M213.063,229.949H172.395a1.031,1.031,0,1,1,0-2.062h40.667a1.031,1.031,0,0,1,0,2.063Zm0,0"
                        transform="translate(-166.238 -217.492)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_144"
                        data-name="Trazado 144"
                        d="M223.185,562.333H183.453a1.032,1.032,0,0,1,0-2.064h39.732a1.032,1.032,0,0,1,0,2.064Zm0,0"
                        transform="translate(-176.265 -518.89)"
                        fill="#797979"
                    />
                    <g
                        id="Grupo_10"
                        data-name="Grupo 10"
                        transform="translate(18.329 0)"
                        clipPath="url(#clip-path)"
                    >
                        <path
                        id="Trazado_145"
                        data-name="Trazado 145"
                        d="M321.592,170.131c-1.536,0-3.777-1.042-5.733-6.005a50.742,50.742,0,0,1-2.844-13.806,1.031,1.031,0,0,1,1.027-1.119h15.1a1.031,1.031,0,0,1,1.028,1.119,50.771,50.771,0,0,1-2.842,13.806C325.37,169.088,323.129,170.131,321.592,170.131Zm-6.418-18.867a47.654,47.654,0,0,0,2.6,12.106c1.177,2.986,2.567,4.7,3.814,4.7s2.636-1.713,3.812-4.7a47.682,47.682,0,0,0,2.6-12.106Zm13.967-14.054h-15.1a1.032,1.032,0,0,1-1.028-1.119,50.748,50.748,0,0,1,2.845-13.81c1.955-4.964,4.2-6.006,5.733-6.006s3.778,1.042,5.732,6.006a50.683,50.683,0,0,1,2.836,13.735,1.08,1.08,0,0,1,.013.162A1.033,1.033,0,0,1,329.141,137.209Zm-13.967-2.064h12.833a47.67,47.67,0,0,0-2.6-12.11c-1.175-2.986-2.564-4.7-3.812-4.7s-2.637,1.712-3.814,4.7A47.688,47.688,0,0,0,315.174,135.146Zm0,0"
                        transform="translate(-313.01 -116.283)"
                        fill="#797979"
                        />
                    </g>
                    <g
                        id="Grupo_11"
                        data-name="Grupo 11"
                        transform="translate(7.702 0)"
                        clipPath="url(#clip-path-2)"
                    >
                        <path
                        id="Trazado_147"
                        data-name="Trazado 147"
                        d="M218.3,170.138a16.755,16.755,0,0,1-12.24-5.674,28.957,28.957,0,0,1-6.939-14.018,1.032,1.032,0,0,1,1.01-1.238h36.333a1.033,1.033,0,0,1,1.011,1.238,28.97,28.97,0,0,1-6.938,14.018A16.756,16.756,0,0,1,218.3,170.138ZM201.425,151.27c2.455,9.957,9.264,16.8,16.878,16.8s14.42-6.848,16.875-16.8Zm35.045-14.054H200.135a1.032,1.032,0,0,1-1.01-1.239,28.965,28.965,0,0,1,6.939-14.022,16.036,16.036,0,0,1,24.477,0,28.949,28.949,0,0,1,6.923,13.948,1.02,1.02,0,0,1,.039.281A1.031,1.031,0,0,1,236.47,137.216Zm-35.045-2.064h33.753c-2.454-9.959-9.263-16.808-16.875-16.808S203.879,125.194,201.425,135.153Zm0,0"
                        transform="translate(-199.094 -116.29)"
                        fill="#797979"
                        />
                    </g>
                    <path
                        id="Trazado_149"
                        data-name="Trazado 149"
                        d="M164.868,374.664l.765,2.286.015.04a4.725,4.725,0,0,1,.216.769c.02-.109.047-.224.079-.343s.08-.273.141-.461l.78-2.291h1.891l-2.172,5.177h-1.293l-.769-2.343c-.04-.133-.077-.267-.11-.4s-.063-.269-.089-.4a7.2,7.2,0,0,1-.2.774l-.009.036-.764,2.337h-1.292l-2.163-5.177h1.882l.774,2.291c.058.167.1.314.139.438a3.676,3.676,0,0,1,.082.367,5.543,5.543,0,0,1,.2-.712c.014-.041.024-.072.031-.092l.769-2.291Zm0,0"
                        transform="translate(-155.834 -350.587)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_150"
                        data-name="Trazado 150"
                        d="M255.417,374.664l.764,2.286.015.04a4.605,4.605,0,0,1,.215.769c.02-.109.048-.224.08-.343s.08-.273.141-.461l.779-2.291H259.3l-2.174,5.177h-1.292l-.769-2.343c-.041-.133-.079-.267-.111-.4s-.063-.269-.09-.4a6.833,6.833,0,0,1-.2.774l-.011.036-.764,2.337H252.6l-2.164-5.177h1.883l.773,2.291c.059.167.1.314.139.438a3.678,3.678,0,0,1,.083.367,5.369,5.369,0,0,1,.2-.712l.031-.092.769-2.291Zm0,0"
                        transform="translate(-237.941 -350.587)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_151"
                        data-name="Trazado 151"
                        d="M345.995,374.664l.763,2.286.016.04a4.678,4.678,0,0,1,.215.769q.03-.164.079-.343c.033-.12.079-.273.141-.461l.779-2.291h1.891l-2.174,5.177h-1.292l-.769-2.343c-.041-.133-.077-.267-.111-.4s-.063-.269-.09-.4a6.893,6.893,0,0,1-.2.774l-.011.036-.763,2.337h-1.292l-2.163-5.177H342.9l.773,2.291c.059.167.1.314.139.438a3.678,3.678,0,0,1,.083.367,5.309,5.309,0,0,1,.2-.712c.015-.041.024-.072.032-.092l.769-2.291Zm0,0"
                        transform="translate(-320.075 -350.587)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_152"
                        data-name="Trazado 152"
                        d="M432.289,411.163a1,1,0,0,1,.294-.733.991.991,0,0,1,.731-.3,1.011,1.011,0,0,1,.743.3,1,1,0,0,1,.3.733,1.028,1.028,0,0,1-1.04,1.041.981.981,0,0,1-.728-.3A1.016,1.016,0,0,1,432.289,411.163Zm0,0"
                        transform="translate(-402.84 -382.749)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_153"
                        data-name="Trazado 153"
                        d="M488.25,415.082H474.84a1.031,1.031,0,1,1,0-2.063h13.41a1.031,1.031,0,1,1,0,2.063Zm0,0"
                        transform="translate(-440.489 -385.367)"
                        fill="#797979"
                    />
                    <g
                        id="Grupo_12"
                        data-name="Grupo 12"
                        transform="translate(0 18.795)"
                        clipPath="url(#clip-path-3)"
                    >
                        <path
                        id="Trazado_154"
                        data-name="Trazado 154"
                        d="M168.343,334.836H118.479a1.031,1.031,0,0,1-.993-.753,26.91,26.91,0,0,1-.974-5.995c0-.016,0-.033,0-.049v-2.524c0-.016,0-.033,0-.049a26.75,26.75,0,0,1,.974-6,1.031,1.031,0,0,1,.992-.752h49.864a1.032,1.032,0,0,1,.993.753,27.166,27.166,0,0,1,0,14.611A1.035,1.035,0,0,1,168.343,334.836Zm-49.069-2.063h48.273a25.14,25.14,0,0,0,0-11.991H119.274a24.714,24.714,0,0,0-.7,4.758v2.474A24.8,24.8,0,0,0,119.274,332.773Zm0,0"
                        transform="translate(-116.499 -318.652)"
                        fill="#797979"
                        />
                    </g>
                    <g
                        id="Grupo_13"
                        data-name="Grupo 13"
                        transform="translate(0 0)"
                        clipPath="url(#clip-path-4)"
                    >
                        <path
                        id="Trazado_156"
                        data-name="Trazado 156"
                        d="M143.113,170.138a26.924,26.924,0,1,1,19.041-7.886A26.755,26.755,0,0,1,143.113,170.138Zm0-51.793a24.865,24.865,0,1,0,24.862,24.867A24.894,24.894,0,0,0,143.113,118.344Zm0,0"
                        transform="translate(-116.202 -116.29)"
                        fill="#797979"
                        />
                    </g>
                    </g>
                    <g id="_4" data-name={4} transform="translate(-21313.303 -15877.264)">
                    <path
                        id="Trazado_158"
                        data-name="Trazado 158"
                        d="M396.412,604.747a.8.8,0,1,0-.767-.831A.834.834,0,0,0,396.412,604.747Zm0,0"
                        transform="translate(-371.91 -560.12)"
                        fill="#797979"
                    />
                    <g
                        id="Grupo_14"
                        data-name="Grupo 14"
                        transform="translate(8.626 0)"
                        clipPath="url(#clip-path-5)"
                    >
                        <path
                        id="Trazado_159"
                        data-name="Trazado 159"
                        d="M241.724,76.02h3.451l-17.9,20.012-7.158-4.987a.745.745,0,0,0-1.087.192l-8.117,10.933a.827.827,0,0,0,.192,1.151.687.687,0,0,0,.511.128.787.787,0,0,0,.639-.32l7.67-10.358,7.031,4.987a.8.8,0,0,0,1.087-.128l18.216-20.46v2.941a.739.739,0,0,0,.767.767.777.777,0,0,0,.767-.767V75.189a.777.777,0,0,0-.767-.767H241.66a.777.777,0,0,0-.767.767A.893.893,0,0,0,241.724,76.02Zm0,0"
                        transform="translate(-210.7 -74.422)"
                        fill="#797979"
                        />
                    </g>
                    <g
                        id="Grupo_15"
                        data-name="Grupo 15"
                        transform="translate(0 10.057)"
                        clipPath="url(#clip-path-6)"
                    >
                        <path
                        id="Trazado_161"
                        data-name="Trazado 161"
                        d="M153.222,200.725a2.143,2.143,0,0,0-2.109-2.174h-6.519a.777.777,0,0,0-.767.767.825.825,0,0,0,.767.767h6.456a.522.522,0,0,1,.511.575v27.812h-2.748V205.136a.777.777,0,0,0-.767-.767h-4.6a.777.777,0,0,0-.767.767v23.4h-3.451v-8.951a.778.778,0,0,0-.767-.767h-4.73a.777.777,0,0,0-.767.767v8.951h-3.452V216.9a.777.777,0,0,0-.767-.767h-4.6a.777.777,0,0,0-.767.767v11.636h-3.452V223.55a.777.777,0,0,0-.767-.767h-4.666a.777.777,0,0,0-.767.767v4.987H105.86v-3.389h4.155a.778.778,0,0,0,.767-.767.825.825,0,0,0-.767-.767H105.86v-3.2h4.155a.778.778,0,0,0,.767-.767.825.825,0,0,0-.767-.767H105.86v-3.2h4.155a.778.778,0,0,0,.767-.767.825.825,0,0,0-.767-.767H105.86v-3.2h4.155a.777.777,0,0,0,.767-.767.825.825,0,0,0-.767-.767H105.86v-3.2h4.155a.767.767,0,0,0,0-1.535H105.86v-3.644a.564.564,0,0,1,.511-.575h29.274a.777.777,0,0,0,.767-.767.825.825,0,0,0-.767-.767h-29.21a2.1,2.1,0,0,0-2.109,2.174l-.064,32.352a2.622,2.622,0,0,0,2.429,2.494h15.851c0,1.151,0,3.069-.064,3.516a1.929,1.929,0,0,1-1.342,1.279h-2.429a.777.777,0,0,0-.767.767.825.825,0,0,0,.767.767h20.134a.777.777,0,0,0,.767-.767.825.825,0,0,0-.767-.767h-2.557a1.654,1.654,0,0,1-1.214-1.279c-.064-.448-.064-2.365-.128-3.516h16.235a2.239,2.239,0,0,0,2.045-2.43Zm-1.534,32.8c0,.384-.192.831-.448.831H106.627a1.019,1.019,0,0,1-.831-.9V230.2h45.828v3.325Zm0,0"
                        transform="translate(-104.24 -198.506)"
                        fill="#797979"
                        />
                    </g>
                    </g>
                    <text
                    id="Sistemas_ERP"
                    data-name="Sistemas ERP"
                    transform="translate(-21288.807 -15799.83)"
                    fill="#797979"
                    fontSize={14}
                    fontFamily="HindMadurai-Regular, Hind Madurai"
                    letterSpacing="0.005em"
                    >
                    <tspan x="-39.725" y={0}>
                        Sistemas ERP
                    </tspan>
                    </text>
                    <text
                    id="Páginas_web"
                    data-name="Páginas web"
                    transform="translate(-21457.193 -15799.83)"
                    fill="#797979"
                    fontSize={15}
                    fontFamily="HindMadurai-Regular, Hind Madurai"
                    letterSpacing="0.005em"
                    >
                    <tspan x="-40.808" y={0}>
                        Páginas web
                    </tspan>
                    </text>
                    <g
                    id="Grupo_208"
                    data-name="Grupo 208"
                    transform="translate(-21395.58 -15856.318)"
                    >
                    <line
                        id="Línea_4"
                        data-name="Línea 4"
                        x2="39.016"
                        transform="translate(9.627 5.279)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    <g
                        id="Elipse_8"
                        data-name="Elipse 8"
                        transform="translate(48.332)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    <g
                        id="Elipse_9"
                        data-name="Elipse 9"
                        transform="translate(0)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    </g>
                    <g
                    id="Grupo_209"
                    data-name="Grupo 209"
                    transform="translate(-21462.162 -15722.588) rotate(-90)"
                    >
                    <line
                        id="Línea_4-2"
                        data-name="Línea 4"
                        x2="39.016"
                        transform="translate(9.627 5.279)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    <g
                        id="Elipse_8-2"
                        data-name="Elipse 8"
                        transform="translate(48.332)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    <g
                        id="Elipse_9-2"
                        data-name="Elipse 9"
                        transform="translate(0)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    </g>
                    <g
                    id="Grupo_210"
                    data-name="Grupo 210"
                    transform="translate(-21293.775 -15722.588) rotate(-90)"
                    >
                    <line
                        id="Línea_4-3"
                        data-name="Línea 4"
                        x2="39.016"
                        transform="translate(9.627 5.279)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    <g
                        id="Elipse_8-3"
                        data-name="Elipse 8"
                        transform="translate(48.332)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    <g
                        id="Elipse_9-3"
                        data-name="Elipse 9"
                        transform="translate(0)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    </g>
                    <g id="So" transform="translate(-21475.398 -15709.615)">
                    <path
                        id="Trazado_1283"
                        data-name="Trazado 1283"
                        d="M591.794,151.047a.541.541,0,0,0,.485.305.48.48,0,0,0,.215-.054.46.46,0,0,0,.269-.305.554.554,0,0,0-.018-.413,17.091,17.091,0,0,0-1.562-2.71.529.529,0,0,0-.431-.233.6.6,0,0,0-.305.09.522.522,0,0,0-.126.736A20.7,20.7,0,0,1,591.794,151.047Zm0,0"
                        transform="translate(-558.411 -139.882)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1284"
                        data-name="Trazado 1284"
                        d="M203.611,64.867a.526.526,0,0,0-.485.574c.036.448.054.915.054,1.382a16.7,16.7,0,0,1-3.716,10.5,16.835,16.835,0,0,0-3.7,9.926l-.018.359h-8.67l.108-.449c.323-1.418,1.615-6.139,4.523-7.737l.126-.072.126.036a3.732,3.732,0,0,0,.718.09,3.458,3.458,0,0,0,2.046-.682,3.4,3.4,0,0,0,1.257-3.877l-1.059-3.231A2.4,2.4,0,0,1,195.8,69L198.549,67a3.476,3.476,0,0,0-2.046-6.283h-3.411a2.408,2.408,0,0,1-2.3-1.669l-1.059-3.231a3.47,3.47,0,0,0-6.606,0l-1.059,3.231a2.391,2.391,0,0,1-2.3,1.669h-3.411A3.476,3.476,0,0,0,174.317,67L177.063,69a2.411,2.411,0,0,1,.88,2.693l-1.059,3.231A3.423,3.423,0,0,0,178.14,78.8a3.511,3.511,0,0,0,2.028.664,3.25,3.25,0,0,0,.718-.072l.126-.036.126.072c2.71,1.472,3.985,5.475,4.523,7.737l.108.449h-8.616l-.018-.359a17.524,17.524,0,0,0-3.841-10.106A16.722,16.722,0,0,1,184.548,50.2a17.135,17.135,0,0,1,1.9-.108c.467,0,.933.018,1.436.054a.527.527,0,0,0,.521-.485.55.55,0,0,0-.485-.574c-.485-.036-.987-.054-1.472-.054a19.438,19.438,0,0,0-2.028.108,17.8,17.8,0,0,0-11.955,28.667,16.347,16.347,0,0,1,3.608,9.532l.018.269-.269.09a1.848,1.848,0,0,0-1.293,1.759v1.723a1.877,1.877,0,0,0,1.867,1.867h.915V96.1a1.877,1.877,0,0,0,1.867,1.867h.736v1.957a2.245,2.245,0,0,0,2.244,2.244h8.6A2.245,2.245,0,0,0,193,99.924V97.968h.736A1.877,1.877,0,0,0,195.6,96.1V93.049h.916a1.877,1.877,0,0,0,1.867-1.867V89.459a1.848,1.848,0,0,0-1.293-1.759l-.269-.09.018-.269a15.877,15.877,0,0,1,3.464-9.352,17.769,17.769,0,0,0,3.949-11.165c0-.5-.018-.987-.054-1.472A.585.585,0,0,0,203.611,64.867ZM180.258,78.42a2.491,2.491,0,0,1-1.436-.467,2.364,2.364,0,0,1-.88-2.693L179,72.029a3.449,3.449,0,0,0-1.257-3.877l-2.764-2.028a2.41,2.41,0,0,1,1.418-4.362h3.41a3.47,3.47,0,0,0,3.3-2.405l1.059-3.231a2.416,2.416,0,0,1,4.6,0l1.059,3.231a3.47,3.47,0,0,0,3.3,2.405h3.41a2.41,2.41,0,0,1,1.418,4.362l-2.747,1.992a3.45,3.45,0,0,0-1.256,3.877l1.059,3.231a2.345,2.345,0,0,1-.88,2.693,2.451,2.451,0,0,1-1.436.467,2.383,2.383,0,0,1-1.4-.467l-2.746-1.993a3.483,3.483,0,0,0-2.046-.664,3.525,3.525,0,0,0-2.046.664l-2.8,2.01A2.286,2.286,0,0,1,180.258,78.42Zm2.369.7-.377-.305,2.782-2.01a2.358,2.358,0,0,1,1.418-.467,2.4,2.4,0,0,1,1.418.467l2.782,2.01-.377.305a12.612,12.612,0,0,0-3.482,5.565l-.341,1.005-.341-1.005A12.511,12.511,0,0,0,182.627,79.12ZM194.546,96.1a.8.8,0,0,1-.808.808h-1.275a.536.536,0,0,0-.538.52v2.477a1.2,1.2,0,0,1-1.185,1.185h-8.58a1.2,1.2,0,0,1-1.185-1.185V97.95h7.718a.536.536,0,0,0,.538-.521.525.525,0,0,0-.538-.52h-9.513a.8.8,0,0,1-.808-.808V93.049h16.191V96.1Zm2.782-6.624V91.2a.8.8,0,0,1-.808.808H176.4a.8.8,0,0,1-.808-.808V89.477a.809.809,0,0,1,.772-.808h.072l.054.018a.726.726,0,0,0,.126.036h19.655a.806.806,0,0,0,.143-.036l.054-.018h.072A.812.812,0,0,1,197.328,89.477Zm0,0"
                        transform="translate(-168.254 -48.622)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1285"
                        data-name="Trazado 1285"
                        d="M498.158,71.511a15.513,15.513,0,0,1,2.531,1.472.6.6,0,0,0,.305.09.505.505,0,0,0,.431-.234.538.538,0,0,0-.126-.736,19.117,19.117,0,0,0-2.692-1.562.48.48,0,0,0-.216-.054.561.561,0,0,0-.485.305A.554.554,0,0,0,498.158,71.511Zm0,0"
                        transform="translate(-472.925 -68.478)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1286"
                        data-name="Trazado 1286"
                        d="M493.523,67.373A14.842,14.842,0,0,1,496,68.809a.933.933,0,0,0,.52.162.889.889,0,0,0,.521-1.616,17.572,17.572,0,0,0-2.764-1.6.96.96,0,0,0-.377-.09.9.9,0,0,0-.377,1.705Zm.233-.88a.148.148,0,0,1,.144-.09.108.108,0,0,1,.072.018,16.785,16.785,0,0,1,2.639,1.526.17.17,0,0,1,.036.233.133.133,0,0,1-.126.072.138.138,0,0,1-.09-.036,16.265,16.265,0,0,0-2.6-1.49A.162.162,0,0,1,493.756,66.494Zm0,0"
                        transform="translate(-468.434 -64.017)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1287"
                        data-name="Trazado 1287"
                        d="M586.609,147.192a.884.884,0,0,0,.808.521.728.728,0,0,0,.377-.09.884.884,0,0,0,.431-1.185,19.334,19.334,0,0,0-1.6-2.764.886.886,0,0,0-.736-.377.936.936,0,0,0-.521.161.877.877,0,0,0-.215,1.239A13.918,13.918,0,0,1,586.609,147.192Zm-.79-3.141c.036-.018.054-.036.09-.036a.133.133,0,0,1,.126.072,17.686,17.686,0,0,1,1.526,2.639.166.166,0,0,1-.072.215.108.108,0,0,1-.072.018.148.148,0,0,1-.144-.09,17.075,17.075,0,0,0-1.49-2.6A.151.151,0,0,1,585.819,144.051Zm0,0"
                        transform="translate(-553.567 -135.865)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1288"
                        data-name="Trazado 1288"
                        d="M277.572,576.313a.062.062,0,0,0-.036.018H257.917c-.018,0-.036-.018-.072-.018l-.126-.036h-.126a1.166,1.166,0,0,0-1.113,1.167v1.723a1.165,1.165,0,0,0,1.167,1.167h20.122a1.164,1.164,0,0,0,1.167-1.167v-1.723a1.165,1.165,0,0,0-1.113-1.167h-.144Zm.646,1.149v1.723a.444.444,0,0,1-.449.449h-20.1a.43.43,0,0,1-.431-.449v-1.723a.422.422,0,0,1,.413-.431,1.249,1.249,0,0,0,.251.054h19.655a.574.574,0,0,0,.251-.054A.411.411,0,0,1,278.218,577.462Zm0,0"
                        transform="translate(-249.52 -536.607)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1289"
                        data-name="Trazado 1289"
                        d="M294.583,635.34h-.736v3.411a1.184,1.184,0,0,0,1.185,1.185h9.513a.162.162,0,0,1,0,.323h-8.1v2.315a1.544,1.544,0,0,0,1.544,1.544h8.6a1.544,1.544,0,0,0,1.544-1.544V640.1a.161.161,0,0,1,.161-.161h1.275a1.184,1.184,0,0,0,1.185-1.185V635.34Zm15.455,3.411a.444.444,0,0,1-.449.449h-1.274a.889.889,0,0,0-.9.9v2.477a.823.823,0,0,1-.826.826h-8.58a.823.823,0,0,1-.826-.826v-1.58h7.341a.9.9,0,1,0,0-1.8h-9.513a.444.444,0,0,1-.449-.449v-2.674H310.02v2.674Zm0,0"
                        transform="translate(-284.105 -591.272)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1290"
                        data-name="Trazado 1290"
                        d="M348.52,419.708a12,12,0,0,1,3.356-5.385l.736-.592-.772-.556-2.387-1.741a2.824,2.824,0,0,0-1.633-.539,2.7,2.7,0,0,0-1.633.539l-2.387,1.741-.772.556.736.592a12.1,12.1,0,0,1,3.357,5.385l.7,2.01Zm-4.29-5.96,2.387-1.741a2.029,2.029,0,0,1,2.405,0l2.387,1.741a12.652,12.652,0,0,0-3.59,5.726A12.562,12.562,0,0,0,344.23,413.749Zm0,0"
                        transform="translate(-329.623 -383.538)"
                        fill="#797979"
                    />
                    <g
                        id="Grupo_150"
                        data-name="Grupo 150"
                        transform="translate(0 0)"
                        clipPath="url(#clip-path-7)"
                    >
                        <path
                        id="Trazado_1291"
                        data-name="Trazado 1291"
                        d="M199.2,59.357h-.072a.9.9,0,0,0-.825.969c.036.449.054.9.054,1.364a16.4,16.4,0,0,1-3.626,10.268A17.2,17.2,0,0,0,190.942,82.1H183.08c.52-2.28,1.885-6.139,4.344-7.5a3.859,3.859,0,0,0,4.452-4.954l-1.059-3.231a2.036,2.036,0,0,1,.736-2.28l2.746-1.992a3.838,3.838,0,0,0-2.244-6.947h-3.411a2.025,2.025,0,0,1-1.939-1.418l-1.059-3.231a3.827,3.827,0,0,0-7.288,0L177.3,53.774a2.042,2.042,0,0,1-1.939,1.418h-3.41a3.838,3.838,0,0,0-2.244,6.947l2.747,1.992a2.01,2.01,0,0,1,.736,2.28l-1.059,3.231a3.848,3.848,0,0,0,3.644,5.026,3.806,3.806,0,0,0,.79-.09c2.639,1.436,3.877,5.565,4.326,7.485h-7.826a17.872,17.872,0,0,0-3.913-10.321,16.363,16.363,0,0,1,12.87-26.459c.449,0,.916.018,1.436.054a.9.9,0,0,0,.072-1.8q-.754-.054-1.508-.054a19.943,19.943,0,0,0-2.064.108,18.139,18.139,0,0,0-12.206,29.241,15.967,15.967,0,0,1,3.536,9.316,2.225,2.225,0,0,0-1.544,2.118v1.723a2.225,2.225,0,0,0,2.226,2.226h.539V90.9a2.245,2.245,0,0,0,2.244,2.244h.377v1.58a2.6,2.6,0,0,0,2.6,2.6h8.6a2.6,2.6,0,0,0,2.6-2.6v-1.58h.377a2.245,2.245,0,0,0,2.244-2.244V88.221h.538a2.225,2.225,0,0,0,2.226-2.226V84.271a2.226,2.226,0,0,0-1.544-2.118,15.36,15.36,0,0,1,3.375-9.137,18.186,18.186,0,0,0,4.039-11.4q0-.754-.054-1.508A.967.967,0,0,0,199.2,59.357ZM195.555,72.64a16.256,16.256,0,0,0-3.536,9.568l-.018.556.52.161a1.481,1.481,0,0,1,1.041,1.418v1.723a1.49,1.49,0,0,1-1.508,1.49H190.78v3.411a1.517,1.517,0,0,1-1.508,1.508H188.16V94.79a1.884,1.884,0,0,1-1.885,1.885h-8.562a1.884,1.884,0,0,1-1.885-1.885V92.475h-1.113a1.517,1.517,0,0,1-1.508-1.508V87.556h-1.275a1.486,1.486,0,0,1-1.49-1.49V84.343a1.481,1.481,0,0,1,1.041-1.418l.521-.161-.018-.556a16.768,16.768,0,0,0-3.68-9.747,17.425,17.425,0,0,1,11.721-28.074A18.436,18.436,0,0,1,182,44.278q.727,0,1.454.054a.152.152,0,0,1,.143.179.154.154,0,0,1-.143.144c-.539-.036-.987-.054-1.454-.054a17.527,17.527,0,0,0-1.939.108,17.093,17.093,0,0,0-11.506,27.536,17.054,17.054,0,0,1,3.77,9.891l.036.7h9.46l-.216-.9c-.538-2.315-1.867-6.426-4.7-7.97l-.234-.126-.269.054a2.646,2.646,0,0,1-.646.072,3.168,3.168,0,0,1-1.813-.592,3.065,3.065,0,0,1-1.131-3.464l1.059-3.231a2.769,2.769,0,0,0-1.005-3.105l-2.746-1.993a3.106,3.106,0,0,1,1.831-5.618h3.41A2.775,2.775,0,0,0,178,54.043l1.059-3.231a3.113,3.113,0,0,1,5.923,0l1.059,3.231a2.775,2.775,0,0,0,2.639,1.921h3.41a3.08,3.08,0,0,1,2.962,2.154,3.023,3.023,0,0,1-1.131,3.464l-2.746,1.993a2.777,2.777,0,0,0-1.005,3.105l1.059,3.231a3.023,3.023,0,0,1-1.131,3.464,3.114,3.114,0,0,1-1.831.61,2.927,2.927,0,0,1-.628-.072l-.269-.054-.233.126c-3.051,1.669-4.362,6.534-4.7,7.97l-.2.9h9.477l.018-.7a16.457,16.457,0,0,1,3.626-9.711,17.168,17.168,0,0,0,3.787-10.734c0-.467-.018-.951-.054-1.418a.261.261,0,0,1,.036-.126.164.164,0,0,1,.126-.054.147.147,0,0,1,.162.143q.054.727.054,1.454A17.843,17.843,0,0,1,195.555,72.64Zm0,0"
                        transform="translate(-163.806 -43.488)"
                        fill="#797979"
                        />
                    </g>
                    <path
                        id="Trazado_1293"
                        data-name="Trazado 1293"
                        d="M245.867,139.373a3.127,3.127,0,0,1,3.662,0l2.746,2.01a2.687,2.687,0,0,0,1.615.539,2.922,2.922,0,0,0,1.651-.539,2.736,2.736,0,0,0,1.005-3.105l-1.059-3.231a3.083,3.083,0,0,1,1.131-3.464l2.746-1.992a2.78,2.78,0,0,0-1.633-5.026h-3.411a3.119,3.119,0,0,1-2.961-2.154l-1.059-3.231a2.773,2.773,0,0,0-5.277,0l-1.059,3.231A3.109,3.109,0,0,1,241,124.564h-3.411a2.747,2.747,0,0,0-2.639,1.921,2.819,2.819,0,0,0,1.059,3.069l2.747,2.01a3.093,3.093,0,0,1,1.131,3.465l-1.059,3.231a2.726,2.726,0,0,0,1.005,3.105,2.794,2.794,0,0,0,1.651.538,2.69,2.69,0,0,0,1.616-.538Zm-4.362,1.813a2.12,2.12,0,0,1-1.22-.413,1.993,1.993,0,0,1-.736-2.28l1.059-3.231a3.833,3.833,0,0,0-1.4-4.29l-2.764-2.01a2.048,2.048,0,0,1,1.2-3.7h3.41a3.8,3.8,0,0,0,3.644-2.657l1.059-3.231a2.034,2.034,0,0,1,3.877,0l1.059,3.231a3.837,3.837,0,0,0,3.644,2.657h3.411a2.048,2.048,0,0,1,1.2,3.7l-2.746,1.992a3.861,3.861,0,0,0-1.4,4.29l1.059,3.231a1.983,1.983,0,0,1-.736,2.28,2.119,2.119,0,0,1-1.221.413,1.99,1.99,0,0,1-1.185-.395l-2.746-2.01a3.842,3.842,0,0,0-4.523,0l-2.746,1.992A1.9,1.9,0,0,1,241.505,141.186Zm0,0"
                        transform="translate(-229.501 -111.765)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1294"
                        data-name="Trazado 1294"
                        d="M493.523,67.373A14.842,14.842,0,0,1,496,68.809a.933.933,0,0,0,.52.162.889.889,0,0,0,.521-1.616,17.572,17.572,0,0,0-2.764-1.6.96.96,0,0,0-.377-.09.9.9,0,0,0-.377,1.705Zm-.108-1.023a.54.54,0,0,1,.485-.305.48.48,0,0,1,.216.054,17.509,17.509,0,0,1,2.692,1.562.522.522,0,0,1,.126.736.554.554,0,0,1-.431.233.6.6,0,0,1-.305-.09,17.843,17.843,0,0,0-2.531-1.472A.566.566,0,0,1,493.416,66.35Zm0,0"
                        transform="translate(-468.434 -64.017)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1295"
                        data-name="Trazado 1295"
                        d="M586.609,147.192a.884.884,0,0,0,.808.521.728.728,0,0,0,.377-.09.884.884,0,0,0,.431-1.185,19.334,19.334,0,0,0-1.6-2.764.886.886,0,0,0-.736-.377.936.936,0,0,0-.521.161.877.877,0,0,0-.215,1.239A13.918,13.918,0,0,1,586.609,147.192Zm-1.005-3.446a.606.606,0,0,1,.305-.09.506.506,0,0,1,.431.233A19.322,19.322,0,0,1,587.9,146.6a.533.533,0,0,1-.251.7.48.48,0,0,1-.215.054.562.562,0,0,1-.485-.305,16.437,16.437,0,0,0-1.472-2.549A.56.56,0,0,1,585.6,143.746Zm0,0"
                        transform="translate(-553.567 -135.865)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1296"
                        data-name="Trazado 1296"
                        d="M299.269,639.94h-.359v3.034a.8.8,0,0,0,.808.808h9.513a.521.521,0,1,1,0,1.041h-7.718v1.938a1.2,1.2,0,0,0,1.185,1.185h8.6a1.2,1.2,0,0,0,1.185-1.185v-2.477a.525.525,0,0,1,.539-.521h1.275a.8.8,0,0,0,.808-.808v-3.034H299.269Zm15.455,3.051a.445.445,0,0,1-.449.449H313a.889.889,0,0,0-.9.9v2.477a.823.823,0,0,1-.826.826H302.7a.823.823,0,0,1-.826-.826v-1.58h7.341a.9.9,0,1,0,0-1.8H299.7a.444.444,0,0,1-.449-.449v-2.674h15.455v2.674Zm0,0"
                        transform="translate(-288.791 -595.513)"
                        fill="#797979"
                    />
                    <g
                        id="Grupo_151"
                        data-name="Grupo 151"
                        transform="translate(0 0)"
                        clipPath="url(#clip-path-7)"
                    >
                        <path
                        id="Trazado_1297"
                        data-name="Trazado 1297"
                        d="M199.2,59.357h-.072a.9.9,0,0,0-.825.969c.036.449.054.9.054,1.364a16.4,16.4,0,0,1-3.626,10.268A17.2,17.2,0,0,0,190.942,82.1H183.08c.52-2.28,1.885-6.139,4.344-7.5a3.859,3.859,0,0,0,4.452-4.954l-1.059-3.231a2.036,2.036,0,0,1,.736-2.28l2.746-1.992a3.838,3.838,0,0,0-2.244-6.947h-3.411a2.025,2.025,0,0,1-1.939-1.418l-1.059-3.231a3.827,3.827,0,0,0-7.288,0L177.3,53.774a2.042,2.042,0,0,1-1.939,1.418h-3.41a3.838,3.838,0,0,0-2.244,6.947l2.747,1.992a2.01,2.01,0,0,1,.736,2.28l-1.059,3.231a3.848,3.848,0,0,0,3.644,5.026,3.806,3.806,0,0,0,.79-.09c2.639,1.436,3.877,5.565,4.326,7.485h-7.826a17.872,17.872,0,0,0-3.913-10.321,16.363,16.363,0,0,1,12.87-26.459c.449,0,.916.018,1.436.054a.9.9,0,0,0,.072-1.8q-.754-.054-1.508-.054a19.943,19.943,0,0,0-2.064.108,18.139,18.139,0,0,0-12.206,29.241,15.967,15.967,0,0,1,3.536,9.316,2.225,2.225,0,0,0-1.544,2.118v1.723a2.225,2.225,0,0,0,2.226,2.226h.539V90.9a2.245,2.245,0,0,0,2.244,2.244h.377v1.58a2.6,2.6,0,0,0,2.6,2.6h8.6a2.6,2.6,0,0,0,2.6-2.6v-1.58h.377a2.245,2.245,0,0,0,2.244-2.244V88.221h.538a2.225,2.225,0,0,0,2.226-2.226V84.271a2.226,2.226,0,0,0-1.544-2.118,15.36,15.36,0,0,1,3.375-9.137,18.186,18.186,0,0,0,4.039-11.4q0-.754-.054-1.508A.967.967,0,0,0,199.2,59.357Zm-3.356,13.5a15.83,15.83,0,0,0-3.464,9.352l-.018.269.269.09a1.848,1.848,0,0,1,1.292,1.759v1.723a1.877,1.877,0,0,1-1.867,1.867h-.9v3.034a1.877,1.877,0,0,1-1.867,1.867h-.736v1.939A2.245,2.245,0,0,1,186.311,97h-8.6a2.244,2.244,0,0,1-2.244-2.244V92.816h-.736a1.877,1.877,0,0,1-1.867-1.867V87.916h-.9a1.877,1.877,0,0,1-1.867-1.867V84.325a1.848,1.848,0,0,1,1.292-1.759l.269-.09-.018-.269a16.3,16.3,0,0,0-3.608-9.532,17.767,17.767,0,0,1,11.955-28.649A15.092,15.092,0,0,1,182,43.9c.5,0,.987.018,1.472.054a.539.539,0,0,1,.485.574.523.523,0,0,1-.5.485c-.539-.036-1.005-.054-1.454-.054a16.72,16.72,0,0,0-16.622,14.827,16.688,16.688,0,0,0,3.464,12.224,17.478,17.478,0,0,1,3.841,10.106l.018.359h8.67l-.108-.448c-.52-2.262-1.795-6.265-4.523-7.737l-.126-.072-.126.036a3.25,3.25,0,0,1-.718.072,3.511,3.511,0,0,1-2.028-.664,3.4,3.4,0,0,1-1.256-3.877l1.059-3.231a2.4,2.4,0,0,0-.88-2.693l-2.764-2.01a3.476,3.476,0,0,1,2.046-6.283h3.41a2.408,2.408,0,0,0,2.3-1.669l1.059-3.231a3.47,3.47,0,0,1,6.606,0l1.059,3.231a2.392,2.392,0,0,0,2.3,1.669h3.41a3.476,3.476,0,0,1,2.046,6.283l-2.746,1.993a2.412,2.412,0,0,0-.88,2.692l1.059,3.231a3.5,3.5,0,0,1-3.3,4.559,3.9,3.9,0,0,1-.718-.09l-.126-.036-.126.072c-2.908,1.6-4.2,6.318-4.524,7.737l-.108.449h8.688l.018-.359a17,17,0,0,1,3.7-9.926,16.809,16.809,0,0,0,3.716-10.5c0-.467-.018-.933-.054-1.382a.549.549,0,0,1,.126-.395.468.468,0,0,1,.359-.179h.054a.527.527,0,0,1,.521.485c.036.485.054.987.054,1.472A18.155,18.155,0,0,1,195.842,72.855Zm0,0"
                        transform="translate(-163.806 -43.488)"
                        fill="#797979"
                        />
                    </g>
                    <path
                        id="Trazado_1299"
                        data-name="Trazado 1299"
                        d="M251.878,142.662a3.524,3.524,0,0,1,2.046.664l2.746,2.01a2.383,2.383,0,0,0,1.4.467,2.491,2.491,0,0,0,1.436-.467,2.364,2.364,0,0,0,.88-2.693l-1.059-3.231a3.45,3.45,0,0,1,1.257-3.877l2.764-2.028a2.41,2.41,0,0,0-1.418-4.362h-3.41a3.47,3.47,0,0,1-3.3-2.405l-1.059-3.231a2.416,2.416,0,0,0-4.595,0L248.5,126.74a3.47,3.47,0,0,1-3.3,2.405H241.79a2.41,2.41,0,0,0-1.418,4.362l2.746,1.992a3.45,3.45,0,0,1,1.256,3.877l-1.059,3.231a2.355,2.355,0,0,0,.88,2.693,2.449,2.449,0,0,0,1.436.467,2.384,2.384,0,0,0,1.4-.467l2.746-1.993A3.8,3.8,0,0,1,251.878,142.662Zm-5.008,2.37a2.019,2.019,0,0,1-1.185.413,2.12,2.12,0,0,1-1.22-.413,1.993,1.993,0,0,1-.736-2.28l1.059-3.231a3.833,3.833,0,0,0-1.4-4.29l-2.764-2.028a2.048,2.048,0,0,1,1.2-3.7h3.41a3.8,3.8,0,0,0,3.644-2.657l1.059-3.231a2.034,2.034,0,0,1,3.877,0l1.059,3.231a3.837,3.837,0,0,0,3.644,2.657h3.41a2.048,2.048,0,0,1,1.2,3.7l-2.746,1.992a3.861,3.861,0,0,0-1.4,4.29l1.059,3.231a1.983,1.983,0,0,1-.736,2.28,2.119,2.119,0,0,1-1.221.413,1.99,1.99,0,0,1-1.185-.395L254.157,143a3.842,3.842,0,0,0-4.523,0Zm0,0"
                        transform="translate(-233.681 -116.006)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1300"
                        data-name="Trazado 1300"
                        d="M282.643,581.34l-.054.018a.551.551,0,0,1-.143.036H262.808a.55.55,0,0,1-.144-.036l-.054-.018h-.054a.809.809,0,0,0-.772.808v1.723a.8.8,0,0,0,.808.808h20.122a.8.8,0,0,0,.808-.808v-1.723a.809.809,0,0,0-.772-.808Zm.485.808v1.723a.444.444,0,0,1-.449.449h-20.1a.43.43,0,0,1-.431-.449v-1.723a.422.422,0,0,1,.413-.431,1.245,1.245,0,0,0,.251.054h19.655a.575.575,0,0,0,.251-.054A.411.411,0,0,1,283.128,582.148Zm0,0"
                        transform="translate(-254.43 -541.293)"
                        fill="#797979"
                    />
                    <path
                        id="Trazado_1301"
                        data-name="Trazado 1301"
                        d="M355.181,424.6l.341-1.005A12.452,12.452,0,0,1,359,418.035l.377-.305-.395-.287L356.6,415.7a2.387,2.387,0,0,0-2.836,0l-2.387,1.741-.395.287.377.305a12.609,12.609,0,0,1,3.482,5.565Zm-3.59-6.839,2.387-1.741a2.029,2.029,0,0,1,2.405,0l2.387,1.741a12.651,12.651,0,0,0-3.59,5.726A12.563,12.563,0,0,0,351.591,417.765Zm0,0"
                        transform="translate(-336.984 -387.555)"
                        fill="#797979"
                    />
                    </g>
                    <text
                    id="Diseño"
                    transform="translate(-21457.193 -15631.182)"
                    fill="#797979"
                    fontSize={15}
                    fontFamily="HindMadurai-Regular, Hind Madurai"
                    letterSpacing="0.005em"
                    >
                    <tspan x="-22.163" y={0}>
                        Diseño
                    </tspan>
                    </text>
                    <g
                    id="Grupo_211"
                    data-name="Grupo 211"
                    transform="translate(-21402.635 -15687.668)"
                    >
                    <line
                        id="Línea_4-4"
                        data-name="Línea 4"
                        x2="39.016"
                        transform="translate(9.627 5.279)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    <g
                        id="Elipse_8-4"
                        data-name="Elipse 8"
                        transform="translate(48.332)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    <g
                        id="Elipse_9-4"
                        data-name="Elipse 9"
                        transform="translate(0)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx="4.969" cy="4.969" r="4.969" stroke="none" />
                        <circle cx="4.969" cy="4.969" r="3.469" fill="none" />
                    </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default ServicesTablet;